import {
  FETCH_HOLIDAYS_START,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_ERROR,
  LOCAL_PURGE,
} from '../actions/types';

const initialState = {
  holidays: [],
  holidaysIsLoading: false,
  holidaysError: null,
};

const fetchHolidaysStart = state => {
  return {
    ...state,
    holidaysIsLoading: true,
  };
};

const fetchHolidaysSuccess = (state, payload) => {
  return {
    ...state,
    holidaysIsLoading: false,
    holidays: payload.holidays,
  };
};

const fetchHolidaysError = (state, payload) => {
  return {
    ...state,
    holidays: [],
    holidaysIsLoading: false,
    holidaysError: payload.error,
  };
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_HOLIDAYS_START:
      return fetchHolidaysStart(state);
    case FETCH_HOLIDAYS_SUCCESS:
      return fetchHolidaysSuccess(state, payload);
    case FETCH_HOLIDAYS_ERROR:
      return fetchHolidaysError(state, payload);
    case LOCAL_PURGE:
      return initialState;
    default:
      return state;
  }
};
